export default __webpack_public_path__ + "static/media/logo-loading.cc1cf2f5.gif";